import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/pages/HomePage.vue';
import ContestPage from '@/pages/Contest/ContestPage.vue';
import MediaPage from '@/pages/Media/MediaPage.vue'; 
import ProjectSubmitterPage from '@/pages/ProjectSubmitter/ProjectSubmitterPage.vue';
import CommissionPage from '@/pages/Commission/CommissionPage.vue';
import QueryPage from '@/pages/Query/QueryPage.vue';
import ContestIndividual from '@/pages/ContestIndividual.vue';
import NotFound from '@/pages/NotFound';
import StatisticsPage from '@/pages/Statistics/StatisticsPage.vue';

// Define the routes
const routes = [
  {
    path: '/o-bazi',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/',
    name: 'Contest',
    component: ContestPage
  },
  {
    path: '/konkurs/:id',
    name: 'IndividualContest',
    /*component: ContestIndividual */// Updated to use ContestIndividual component
    component: ContestPage
  },
  {
    path: '/pretraga/mediji',
    name: 'Media',
    component: MediaPage
  },
  {
    path: '/pretraga/podnosioc-projekta', 
    name: 'ProjectSubmitter',
    component: ProjectSubmitterPage
  },
  {
    path: '/pretraga/komisija',
    name: 'Commission',
    component: CommissionPage
  },
  {
    path: '/upiti',
    name: 'Query',
    component: QueryPage
  },
    {
    path: '/statistika',
    name: 'Statistics',
    component: StatisticsPage
  },
  {
    path: '/pojedinacan-konkurs',
    name: 'ContestIndividual',
    component: ContestIndividual
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound
  }
];

// Create the router instance
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth', // optional, adds smooth scrolling
      }
    }
    return { top: 0 }
  }
});

export default router;